module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "control_panel"
    }
  }, [_c('div', {
    attrs: {
      "id": "control_panel_portrait"
    }
  }, [(_vm.portrait == 'Default') ? _c('img', {
    attrs: {
      "src": require("./img/portrait_default.svg")
    }
  }) : (_vm.portrait == 'Aye') ? _c('img', {
    attrs: {
      "src": require("./img/portrait_aye.svg")
    }
  }) : (_vm.portrait == 'Ria') ? _c('img', {
    attrs: {
      "src": require("./img/portrait_ria.svg")
    }
  }) : (_vm.portrait == 'Devyn') ? _c('img', {
    attrs: {
      "src": require("./img/portrait_devyn.svg")
    }
  }) : (_vm.portrait == 'Hailey') ? _c('img', {
    attrs: {
      "src": require("./img/portrait_hailey.svg")
    }
  }) : (_vm.portrait == 'Reece') ? _c('img', {
    attrs: {
      "src": require("./img/portrait_reece.svg")
    }
  }) : (_vm.portrait == 'Dylan') ? _c('img', {
    attrs: {
      "src": require("./img/portrait_dylan.svg")
    }
  }) : (_vm.portrait == 'Skylar') ? _c('img', {
    attrs: {
      "src": require("./img/portrait_skylar.svg")
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    class: {
      inactive: !_vm.control_panel_active
    },
    attrs: {
      "id": "control_panel_next"
    },
    on: {
      "click": _vm.next,
      "mousedown": _vm.button_down,
      "mouseup": _vm.button_up
    }
  }, [_c('div', {
    class: {
      down: _vm.button_press, inactive: !_vm.control_panel_active
    },
    attrs: {
      "id": "next_button"
    }
  }, [_c('svg', {
    attrs: {
      "id": "arrow",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "24",
      "viewBox": "0 0 14 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#848484",
      "fill-rule": "evenodd",
      "d": "M2.66 0L0 2.82 8.65 12 0 21.18 2.66 24 14 12"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "control_panel_text"
    }
  }, [_c('span', {
    staticClass: "control_panel_copy"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560b0866","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/control_panel/control_panel.vue
// module id = 551
// module chunks = 1